import { NewsModel } from '../models/News.model';
import { FeedItemDTO } from '../../feedItems/dtos/FeedItem.dto';
import { NewsRequestDTO, NewsFeedItemType } from '../infra/types';
import { TagUtil } from '../../tags/utils/TagUtil';

export class NewsUtil {
  public static mapToViewModel(dto: FeedItemDTO<NewsFeedItemType>): NewsModel {
    return {
      id: dto.id,
      headline: dto.headline,
      tagline: dto.tagline,
      coverImage: dto.coverImage,
      body: dto.feedItem.body,
      access: dto.access,
      status: dto.status,
      tags: dto.tags ? dto.tags.map((tag) => TagUtil.mapToViewModel(tag)) : [],
      publishedOn: dto.publishedOn,
      recipients: dto.recipients,
      citationRequired: dto.citationRequired,
      feedType: 'NewsItem',
    };
  }

  public static toRequestDTO(model?: NewsModel): NewsRequestDTO {
    return {
      id: model ? model.id : undefined,
      headline: model ? model.headline : '',
      tagline: model ? model.tagline : undefined,
      body: model ? model.body : '',
      tags: model ? model.tags : [],
      status: model ? model.status : 'DRAFT',
      coverImage: model ? model.coverImage : undefined,
      citationRequired: model ? model.citationRequired : false,
    };
  }
}
